module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAALCAYAAACd1bY6AAAABGdBTUEAALGPC/xhBQAAAJdJREFUKBWljUkOgCAQBDn5TI/+xANuYfEjPsQ3YWN6kiHBuJHgQNNVmpRSg92ZHyvz2WPwabHzWr/4MnfS8Jw8LpZBfCMEE8nZgkM4vBEq0VCI5KKEQbLaRC/wx3WRQCiNLHrJ9MSb5/uo88szyhMBp0vIHPNJ57dnQLMWKtF8C9cKECwU7pzfRCKHZKNok+zXhKx/IjgAhf7JKmg8QLwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/caret-white.png
// module id = ./assets/caret-white.png
// module chunks = 35783957827783